import { render, staticRenderFns } from "./index.vue?vue&type=template&id=535aa00a"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('535aa00a')) {
      api.createRecord('535aa00a', component.options)
    } else {
      api.reload('535aa00a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=535aa00a", function () {
      api.rerender('535aa00a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/GpsViews/Admin/Plants/Plant/Production/checkup/index.vue"
export default component.exports